import { Component, OnChanges, ChangeDetectionStrategy, output, input } from '@angular/core';
import {PerformanceDefaults} from "../../model/performance-defaults";
import {FormsModule} from "@angular/forms";


@Component({
    selector: 'app-performance-defaults',
    imports: [
    FormsModule
],
    templateUrl: './performance-defaults.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './performance-defaults.component.css'
})
export class PerformanceDefaultsComponent implements OnChanges {

  readonly performanceDefaultsInput = input.required<PerformanceDefaults>({ alias: 'performanceDefaults' });
  readonly selectionChanged = output<PerformanceDefaults>();
  fluidTypes: string[] = ['Water', 'Ethanol', 'Ethylene Glycol', 'Methanol', 'Propylene Glycol'];

  constructor() {
  }

  ngOnChanges(): void {
  }

  valueChanged(): void {
    this.selectionChanged.emit(this.performanceDefaultsInput());
  }

}
